import React, { useEffect, useState } from 'react';

const BackgroundEffects = () => {
  const [particles, setParticles] = useState([]);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // Generate random binary particles - subtler for black hole theme
    const generateParticles = () => {
      const newParticles = [];
      const particleCount = 200; // Increased from 100

      for (let i = 0; i < particleCount; i++) {
        newParticles.push({
          id: i,
          char: Math.random() > 0.5 ? '0' : '1',
          left: Math.random() * 100, // % position
          animationDuration: 5 + Math.random() * 25,
          animationDelay: Math.random() * 20,
          opacity: 0.2 + Math.random() * 0.5, // Increased opacity (0.2 to 0.7)
          size: 10 + Math.random() * 14 // Slightly larger
        });
      }
      setParticles(newParticles);
    };

    generateParticles();

    // Mouse movement handler for parallax
    const handleMouseMove = (e) => {
      setMousePos({
        x: (e.clientX / window.innerWidth - 0.5) * 20, // -10 to 10
        y: (e.clientY / window.innerHeight - 0.5) * 20
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);





  return (
    <>
      {/* Floating Binary Particles */}
      <div className="particles-container">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="particle"
            style={{
              left: `${particle.left}%`,
              animationDuration: `${particle.animationDuration}s`,
              animationDelay: `${particle.animationDelay}s`,
              fontSize: `${particle.size}px`,
              '--particle-opacity': particle.opacity
            }}
          >
            {particle.char}
          </div>
        ))}
      </div>

      {/* BLACK HOLE SINGULARITY EFFECT */}
      
      {/* Parallax Container */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: `translate(calc(-50% + ${mousePos.x * -1.5}px), calc(-50% + ${mousePos.y * -1.5}px))`,
        width: '1000px', // Increased container size to prevent clipping
        height: '1000px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 0,
        pointerEvents: 'none',
        transition: 'transform 0.1s ease-out'
      }}>
        
        {/* Accretion Disk - Outer Swirl */}
        <div style={{
          position: 'absolute',
          width: '700px', // More defined but still large
          height: '700px',
          borderRadius: '50%',
          background: 'conic-gradient(from 0deg, transparent 0%, rgba(20, 60, 80, 0.5) 20%, transparent 60%)',
          animation: 'spin 25s linear infinite',
          filter: 'blur(30px)', // Reduced blur for more presence
          opacity: 0.8 // Increased opacity for boldness
        }}></div>

        {/* Accretion Disk - Inner Fast Ring */}
        <div style={{
          position: 'absolute',
          width: '420px', // Increased size
          height: '420px',
          borderRadius: '50%',
          border: '2px solid rgba(100, 200, 255, 0.2)', // Thicker border
          borderLeft: '6px solid rgba(0, 255, 255, 0.8)', // Thicker accent
          borderRight: '2px solid transparent',
          boxShadow: '0 0 50px rgba(0, 217, 255, 0.4)', // Stronger glow
          animation: 'spin 4s linear infinite',
          filter: 'blur(1px)'
        }}></div>

        {/* Event Horizon (The Void) */}
        <div style={{
          position: 'absolute',
          width: '320px', // Increased size
          height: '320px',
          borderRadius: '50%',
          background: '#000', // Pure black hole
          boxShadow: `
            inset 0 0 80px rgba(0, 0, 0, 1),
            0 0 30px rgba(0, 217, 255, 0.6), 
            0 0 80px rgba(0, 150, 255, 0.4),
            0 0 120px rgba(255, 255, 255, 0.15)
          `,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
           {/* Singularity Core Text */}
           <div style={{
             transform: `translate(${mousePos.x * 0.5}px, ${mousePos.y * 0.5}px)`, // Separate parallax
             transition: 'transform 0.1s ease-out',
             display: 'flex',
             flexDirection: 'column',
             alignItems: 'center',
             gap: '8px'
           }}>
             <div style={{
               color: '#fff',
               fontSize: '20px', // Slightly larger font
               fontFamily: '"Orbitron", monospace',
               letterSpacing: '8px',
               fontWeight: 'bold',
               textShadow: '0 0 15px rgba(255,255,255,0.9)'
             }}>
               SYSTEM
             </div>
             <div style={{
               width: '6px', // Larger dot
               height: '6px',
               background: '#00ffff',
               borderRadius: '50%',
               boxShadow: '0 0 20px #00ffff'
             }}></div>
           </div>
        </div>



        {/* Gravity Lensing (Distortion Ring) */}
        <div style={{
          position: 'absolute',
          width: '360px', // Matched scale
          height: '360px',
          borderRadius: '50%',
          boxShadow: 'inset 0 0 40px rgba(255, 255, 255, 0.15)',
          animation: 'pulse 4s ease-in-out infinite',
          zIndex: 3,
          pointerEvents: 'none'
        }}></div>

      </div>
    </>
  );
};

export default BackgroundEffects;
